var jsonDataUrl = $('.jsc-watch-finder').attr('sheety-api'); 
var blankLi = `<li class="custom-select--item custom-select__option js-option" id="jsc-brand-blank" role="option" data-value="blank"></li>`;
let cachedWatchDb = null;

const fetchWatchDb = () => {
    return $.getJSON(jsonDataUrl).then((jsonData) => {
        cachedWatchDb = jsonData.sheet1;
       return cachedWatchDb;
    });
};

$(function () {
    fetchWatchDb().then(() => {
    onLoadFunctionInit();
    }); 
});

openWfDrawer = (sfPageType) =>{
    $('#Watch-Finder--Drawer').addClass('active');
    $('body').addClass('open-cc');

    onLoadSetLocalStorage();
    var getBrandLocalStorage = localStorage.getItem('brand'); 
    var getModelLocalStorage = localStorage.getItem('model');

    if (sfPageType == 'brand' || sfPageType == 'model'){
        $('jsc-watch-finder--drop-down').attr('sfPageType',sfPageType);
        $('#jsc-brand button input').attr('disabled',true);
        $('#jsc-brand button span').removeAttr('onclick');
        $('.jsc-watch-finder--clear').hide();
    }else{
        $('jsc-watch-finder--drop-down').attr('sfPageType',sfPageType);
        $('#jsc-brand button input').attr('disabled',false);
        $('#jsc-brand button span').attr('onclick','toggleBrandDropdown()');
        $('.jsc-watch-finder--clear').show();
    }

            loadBrandOption(getBrandLocalStorage);
            var brandValue = "Brand: " + getBrandLocalStorage;
            $('#jsc-brand .custom-select--button .jsc-brand-search').attr('placeholder',brandValue);
            $('#jsc-brand .custom-select--button .jsc-brand-search').val(brandValue);
            $('#jsc-brand .custom-select--button .jsc-brand-search').addClass('jsc-placeholder-black-color');
   
            loadModelOption (getBrandLocalStorage, sfPageType) ;
            var modelValue = "Collection: " + getModelLocalStorage;
            $('#jsc-model .custom-select--button .jsc-model-search').attr('placeholder',modelValue);
            $('#jsc-model .custom-select--button .jsc-model-search').val(modelValue);
            $('#jsc-model .custom-select--button .jsc-model-search').addClass('jsc-placeholder-black-color');
            loadEngineOption(getModelLocalStorage,sfPageType,getBrandLocalStorage);

             // pre open model dropdown for brand and model page  
            if (sfPageType === 'brand' || sfPageType === 'model') {
                setTimeout(function () {
                  const modelContainer = $('#jsc-model');
                  const modelItems = modelContainer.find('ul li');
              
                  if (modelItems.length > 1) {
                    modelContainer.addClass('custom-select--active');
                  } else {
                    // Disable the input inside #jsc-model
                    modelContainer.find('input').prop('disabled', true);
                    modelContainer.find('button span').removeAttr('onclick');

                  }
                }, 100);
              }
}

if ($('jsc-watch-finder--drop-down').length > 0) { // only for watch finder template
    $(document).on('click', function(event) {
        var $dropdown = $('jsc-custom-select button');
        var getBrandLocalStorage = localStorage.getItem('brand');
        var getModelLocalStorage = localStorage.getItem('model');
    
        if (!$dropdown.is(event.target) && $('.jsc-custom-select').has(event.target).length === 0) {
            // Close the dropdown if it is open
            if ($('.jsc-custom-select').hasClass('custom-select--active')) {
                $('.jsc-custom-select').removeClass('custom-select--active');
                if (getBrandLocalStorage) {
                    $('#jsc-brand .custom-select--button .jsc-brand-search').addClass('jsc-placeholder-black-color');
                }else{
                    $('#jsc-brand .custom-select--button .jsc-brand-search').removeClass('jsc-placeholder-black-color');
                }
                if (getModelLocalStorage) {
                    $('#jsc-model .custom-select--button .jsc-model-search').addClass('jsc-placeholder-black-color');
                }else{
                    $('#jsc-model .custom-select--button .jsc-model-search').removeClass('jsc-placeholder-black-color');
                }
            }
        }
    });
}

onLoadSetLocalStorage = () => {
  // Only run if the URL has brand in query string
  if (window.location.search.includes('?brand=')) {
        // Parse and clean URL parameters
        const queryString = window.location.search.substring(1);
        const fixedQueryString = queryString.replace(/collection=/, '&collection=').replace(/reference=/, '&reference=');
        const urlParams = new URLSearchParams(fixedQueryString);

        const rawBrand = urlParams.get('brand') || '';
        const rawModel = urlParams.get('collection') || '';
        const rawYear = urlParams.get('reference') || '';

        const cleanBrand = encodeURIComponent(rawBrand.replace(/\s+/g, ''));
        const cleanModel = encodeURIComponent(rawModel.replace(/\s+/g, ''));
        const cleanYear = encodeURIComponent(rawYear.replace(/\s+/g, ''));

        // console.log('🔍 Encoded URL Parameters:',
        //     cleanBrand,
        //     cleanModel,
        //     cleanYear);

        // Search in cached DB
        var watchDb = cachedWatchDb;

        var match = watchDb.find(item => {
         
            const encodedBrand = encodeURIComponent(String(item.brand || '').replace(/\s+/g, ''));
            const encodedModel = encodeURIComponent(String(item.collection || '').replace(/\s+/g, ''));
           const encodedReference = encodeURIComponent(String(item.reference || '').replace(/\s+/g, ''));

            // Log comparison for debugging
            // console.log(`🧪 Checking: ${encodedBrand}, ${encodedModel}, ${encodedReference}`);

            return (
                encodedBrand === cleanBrand &&
                encodedModel === cleanModel  &&
                encodedReference === cleanYear
            );
        });

        if (match) {
            localStorage.setItem('brand', match.brand);
            localStorage.setItem('model', match.collection);
            localStorage.setItem('reference', match.reference);
            // console.log('✅ Match found & saved to localStorage:', match);
        } else {
            // console.log('❌ No match found for brand/collection/year in watchDb.');
        }
    }
}

onLoadFunctionInit = () =>{
    onLoadSetLocalStorage();
    // console.log('DB', cachedWatchDb);
    var getBrandLocalStorage = localStorage.getItem('brand');
    var getModelLocalStorage = localStorage.getItem('model');
    var getReferenceLocalStorage = localStorage.getItem('reference');
    loadBrandOption(getBrandLocalStorage);
    onloadPopulateWatchFilterFromLocalStorage(getBrandLocalStorage,getModelLocalStorage);
    if ($('jsc-watch-finder--drop-down').length > 0) { // only for watch finder template
        onloadWatchButton(getBrandLocalStorage,getModelLocalStorage);
    }else{
        onloadPopulateReferenceFilterFromLocalStorage(getBrandLocalStorage,getModelLocalStorage,getReferenceLocalStorage);
    }
}

handleizedString = (input) => {
    let string = String(input);
    return string.replace(/\s+/g, '-').replace(/\//g, '-').trim().toLowerCase().replace('(', '-').replace(')', '-').replace(/--/g, '-').replace('.', '-').replace(/√∂/g, '-');
}

populateModelHtml = (brand, localStorageModel, sfPageType) => {

    // Filter the JSON data for the selected "Brand"
    var filteredData = cachedWatchDb.filter(function(item) {
        if (sfPageType === 'brand') {
            // For brand-specific pages, only show models that match the brand
            // and have a brand-specific collection
            return item.status === 1 &&
                   item.brand === brand && 
                   item.brandSpecificCollection && 
                   item.brandSpecificCollection.includes('/collections');
        } 
        else if  (sfPageType === 'model'){
             // For model landing pages, only show models that match the brand
            // and have a model-landing page
            return item.status === 1 &&
                   item.brand === brand && 
                   item.modelLandingPage && 
                   item.modelLandingPage.includes('/pages');
        }else {
            // For non-brand-specific pages, show all models for the brand
            return item.status === 1 && item.brand === brand;
        }
    });

    var modelUlElement = $('#jsc-model .custom-select__listbox');
    var modelOptions = [...new Set(filteredData.map(item => item.collection))].sort().map(model => {
        var handleizedModel = handleizedString(model);
        return `<li class="custom-select--item custom-select__option js-option" id="jsc-model-${handleizedModel}" role="option" data-value="${model}" onclick="selectOption(this,'model')" ${model == localStorageModel ? 'aria-selected="true"': 'aria-selected="false"' }>
                <span class="${model == localStorageModel ? 'custom-select--active' : ''}">${model}</span>
                </li>`;
    });

    modelUlElement.html(modelOptions.join(''));
}

populateReferenceHtml = (brand, model, localStorageReference) => {
    // Filter the JSON data for the selected "Brand" and "Model"
    var filteredData = cachedWatchDb.filter(function(item) {
        return item.status === 1 && item.brand === brand && item.collection === model;
    });

    var modelUlElement = $('#jsc-reference .custom-select__listbox');
    var modelOptions = [...new Set(filteredData.map(item => item.reference))].sort().map(reference => {
        var handleizedReference = handleizedString(reference); 
        return `<li class="custom-select--item custom-select__option js-option" id="jsc-reference-${handleizedReference}" role="option" data-value="${reference}" onclick="selectOption(this,'reference')" ${reference == localStorageReference ? 'aria-selected="true"': 'aria-selected="false"' }>
                <span class="${reference == localStorageReference ? 'custom-select--active' : ''}">${reference}</span>
                </li>`;
    });

    modelUlElement.html(modelOptions.join(''));
};

populateReferenceImageHtmlByBrand = (brand,isPageType) => {
    let brandString = String(brand);
      // Filter the JSON data for the selected "Brand"
      var filteredData = cachedWatchDb.filter(function(item) {
        return item.status === 1 &&  
               String(item.brand).trim() === brandString;
    });
    
    var engineUlElement = $('jsc-year-reference-img');
    engineUlElement.empty();
            
    var tableHTMLArray = filteredData.map(item => {
    // Get unique yearnum values for the current engineImg
    var uniqueYearNums = [...new Set(filteredData.filter(data => data.watchImage === item.watchImage).map(data => data.reference))];
    // Join unique yearnum values into a comma-separated string
    var yearNumString = uniqueYearNums.join(', ');
    // Collect article handles (only if they exist)
    var articleHandles = [item.article1, item.article2, item.article3].filter(Boolean).join('>');
    // console.log(articleHandles, 'articleHandles'); 
    // Store the data in the array
    return `${yearNumString},${item.watchImage},${item.caseDiameter},${item.lugToLugDistance},${item.lugWidth},${item.watchHeadImage},${articleHandles},${item.recommendedCollection},${item.brand},${item.collection},${item.brandSpecificPage},${item.model},${item.modelLandingPage}`;
     });
//   console.log('tableHTMLArray', tableHTMLArray, 'isPageType', isPageType);
    loadTableRow(tableHTMLArray,isPageType);
}

populateReferenceImageHtml = (model,isPageType,brand) => {
    let modelString = String(model); 
    let brandString = String(brand);
      // Filter the JSON data for the selected "Model" and "Brand"
      var filteredData = cachedWatchDb.filter(function(item) {
        return item.status === 1 && 
                String(item.collection).trim() === modelString &&
               String(item.brand).trim() === brandString;
    });

    
    var engineUlElement = $('jsc-year-reference-img');
    engineUlElement.empty(); // Remove existing children
            
    var tableHTMLArray = filteredData.map(item => {
    // Get unique yearnum values for the current engineImg
    var uniqueYearNums = [...new Set(filteredData.filter(data => data.watchImage === item.watchImage).map(data => data.reference))];
    // Join unique yearnum values into a comma-separated string
    var yearNumString = uniqueYearNums.join(', ');
    // Collect article handles (only if they exist)
    var articleHandles = [item.article1, item.article2, item.article3].filter(Boolean).join('>');
    // console.log(articleHandles, 'articleHandles'); 
    // Store the data in the array
    return `${yearNumString},${item.watchImage},${item.caseDiameter},${item.lugToLugDistance},${item.lugWidth},${item.watchHeadImage},${articleHandles},${item.recommendedCollection},${item.brand},${item.collection},${item.brandSpecificPage},${item.model},${item.modelLandingPage}`;
     });

    loadTableRow(tableHTMLArray,isPageType);
}

loadTableRow = (htmlArray, isPageType) => {
    var engineUlElement = $('jsc-year-reference-img');
    engineUlElement.children().remove();
    const row = $('<div>').addClass('jsc-year-img-items-wrapper');
    var getReferenceLocalStorage = localStorage.getItem('reference');
  
    let appendedCount = 0; // Track how many items get appended
    const cardList = [];   // Store product cards temporarily

    let customerId = $('jsc-watch-finder').attr('customer-id');
    let customerMetafieldData = $('jsc-watch-finder').attr('customer-save-watch-list');
    let watchList = customerMetafieldData ? JSON.parse(customerMetafieldData) : [];

    if (watchList.length >= 50){
        $('.sf-saved-watch-error-limit-message').show();
    }
    for (let index = 0; index < htmlArray.length; index++) {
      const parts = htmlArray[index].split(',');

      let heartFill = 'none'; // default

        if (customerId && Array.isArray(watchList)) {
        const isWatchListed = watchList.some(item => {
            return  item.brand === parts[8] && item.collection === parts[9] && item.reference === parts[0] ;
        });

        heartFill = isWatchListed ? '#000000' : 'none';
        }
     
        let isLimitReached = Array.isArray(watchList) && watchList.length >= 50;
  
      // Check if the current card should be shown
      const passesFilter = (() => {
        if (isPageType === 'brand') {
          return parts[10] && parts[10].includes('/pages');
        } else if (isPageType === 'model') {
          return parts[12] && parts[12].includes('/pages');
        } else {
          return true;
        }
      })();
  
      if (!passesFilter) continue;
  
      // Build product card
      const productInput = $('<input>')
        .addClass('jsc-year-img-data')
        .addClass(isLimitReached === true ? 'sf-save-watch-reached' : '')
        .attr('type', 'hidden')
        .attr('year-ref', parts[0])
        .attr('year-src', parts[1])
        .attr('case-diameter', parts[2])
        .attr('lug-to-lug-distance', parts[3])
        .attr('lug-width', parts[4])
        .attr('watch-face', parts[5])
        .attr('article-urls', parts[6])
        .attr('recommend-collection', parts[7])
        .attr('brand', parts[8])
        .attr('watch', parts[9])
        .attr('brand-specific-page', parts[10])
        .attr('model', parts[11])
        .attr('model-landing-page', parts[12]);
  
      const productCard = $('<div>')
        .addClass(`jsc-year-img-item cursor columns carousel__slide`) // size class added later
        .attr(
          'onclick',
          `setLocalStorage('reference','${parts[0].trim()}');constructParamUrl('${index}',this,'${isPageType}');showWatchInfo();`
        );
  
      const productCardContent = $('<div>')
        .addClass(`product-card-${index} product-card text-left product-card--content-spacing-true product-card--border-false`);

        const saveWatch = $('<div>')
            .addClass('jsc-sf-product-card-save-watch') 
            .addClass(heartFill === '#000000' ? 'sf-filled' : '')
            .addClass(isLimitReached && heartFill === 'none' ? 'sf-disabled' : '')
            .append(
                $('<div>')
                .addClass('sf-save-watch-button')
                .append(
                    $('<span>')
                    .addClass('sf-save-watch-icon')
                    .html(`
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 25 22" fill="none">
                        <path d="M12.4869 22C12.2364 21.9968 11.9918 21.9232 11.7804 21.7875C8.18822 19.57 5.48518 17.3766 3.2783 14.8705C2.01853 13.5287 1.04215 11.942 0.408559 10.207C-0.730606 6.84675 0.5832 2.9211 3.46882 1.07256C4.78425 0.221399 6.35422 -0.134962 7.90363 0.0659208C9.45304 0.266804 10.8831 1.01212 11.9431 2.17126C12.1376 2.37977 12.3162 2.60031 12.4869 2.81685C12.7194 2.51694 12.97 2.2317 13.2371 1.96275C13.8816 1.32075 14.6473 0.816306 15.4888 0.479444C16.3303 0.142583 17.2302 -0.0198119 18.1351 0.00192686C19.0214 0.0266866 19.8936 0.23235 20.6992 0.606539C21.5048 0.980728 22.2271 1.51571 22.8227 2.17928C25.0693 4.63732 25.6012 7.62065 24.3072 10.8045C23.6255 12.404 22.6611 13.8647 21.4613 15.1151C19.3548 17.3836 16.9713 19.3724 14.3683 21.0336C14.019 21.2662 13.6578 21.4907 13.3006 21.7113L13.1934 21.7795C12.9825 21.9174 12.738 21.9937 12.4869 22Z"
                            stroke="#000000" fill="${heartFill}"></path>
                        </svg>
                    `)
                )
                .on('click', function (e) {
                    e.stopPropagation(); // Prevent card click
                    e.preventDefault(); // ⛔ Prevent anchor href navigation if inside <a>

                    // if ($(this).hasClass('disabled')) return; // ⛔ Block if disabled

                    const svgPath = $(this).find('svg path');
                    const isFilled = svgPath.attr('fill') === '#000000';
                    const saveWatchParent = $(this).closest('.jsc-sf-product-card-save-watch');

                    // ⛔ If limit reached and not already saved, don't allow adding
                    customerMetafieldData = $('jsc-watch-finder').attr('customer-save-watch-list');
                    watchList = customerMetafieldData ? JSON.parse(customerMetafieldData) : [];
                    isLimitReached = Array.isArray(watchList) && watchList.length >= 50;
                    if (isLimitReached && !isFilled) {
                      
                        return;
                    }
                    
                     // construct url params
                    var $cu_brand =  parts[8].replace(/\s+/g, '');
                    var $cu_collection = parts[9].replace(/\s+/g, '');
                    var $cu_reference = parts[0].replace(/\s+/g, '');
                    // Construct URL properly
                    var sf_page_handle = $('.jsc-watch-finder').attr('sf-page');
                    var $cu_urlWithParams = `/pages/${sf_page_handle}?brand=${encodeURIComponent($cu_brand)}collection=${encodeURIComponent($cu_collection)}reference=${encodeURIComponent($cu_reference)}`;

                    const watchData = {
                      brand: parts[8],
                      collection: parts[9],
                      model: parts[11],
                      reference: parts[0],
                      watchImage: parts[1],
                      url: $cu_urlWithParams 

                    };
                    

                    if (customerId){
                        if (isFilled) {
                            // allow all to save
                            $('.jsc-sf-product-card-save-watch').removeClass('sf-disabled');
                            saveWatchParent.removeClass('sf-filled');
                            // If already filled, remove from list
                            removeFromWatchList(watchData);
                            svgPath.attr('fill', 'none');
                          } else {
                            // If not filled, add to list
                            addToWatchList(watchData);
                            svgPath.attr('fill', '#000000');
                            saveWatchParent.addClass('sf-filled');

                          }
                            customerMetafieldData = $('jsc-watch-finder').attr('customer-save-watch-list');
                            watchList = customerMetafieldData ? JSON.parse(customerMetafieldData) : [];
                            isLimitReached = Array.isArray(watchList) && watchList.length >= 50;
                            if (watchList.length >= 50) {
                                $('.sf-saved-watch-error-limit-message').show();
                                $('.jsc-sf-product-card-save-watch:not(.sf-filled)').addClass('sf-disabled');
                            }else{
                                $('.sf-saved-watch-error-limit-message').hide();
                            }
                    }else{

                        if (window.location.pathname.includes('/account')) {
                            $('#Watch-Finder--Drawer').removeClass('active');
                            $('body').removeClass('open-cc');
                          } else {
                            showPopupLoginForm(); 
                            openSfLoginPopup();
                          }
                    }


                  })
        );

        
      const productImage = $('<div>')
        .addClass('jsc-year-img')
        .append(
          $('<img>')
            .addClass('no-blur product-secondary-image lazyautosizes ls-is-cached lazyloaded')
            .attr('src', parts[1])
        );
  
      const productInfo = $('<div>').addClass('product-card-info');
      const productReferenceLabel = $('<div>')
        .addClass('jsc-year-reference-label')
        .text('Reference ')
        .append($('<span>').addClass('jsc-year-reference').text(parts[0]));
      const productModelLabel = $('<div>').addClass('jsc-model-label').append($('<span>').text(parts[11]));
  
      if (parts[0] == getReferenceLocalStorage) {
        productCardContent.addClass('border-active');
      }
  
      productCard.prepend(productInput);
      productCardContent.append(productImage);
    //   if (isPageType !== 'brand' && isPageType !== 'model') {
    //     productCardContent.append(saveWatch);
    //   }
      productCardContent.append(productInfo);
      productInfo.append(productModelLabel);
      productInfo.append(productReferenceLabel);
      productCard.append(productCardContent);
  
      cardList.push(productCard);
      appendedCount++;
    }
  
    
    // After loop: determine size class
    const sizeClass = appendedCount === 1 ? 'small-6 medium-12 large-12' : 'small-6 medium-6 large-6';
  
    cardList.forEach(card => {
      card.addClass(sizeClass);
      row.append(card);
    });
  
    engineUlElement.append(row);
    removeLoader();
}
  

sfPopupClose = () =>{

    // Check if current URL has #recover
    if (window.location.hash === '#recover') {
    var returnUrl = window.location.pathname + window.location.search;
    window.location.href = returnUrl; 
    }else{
    $('#sf_download_login_modal').hide();
    $('body').removeClass('open-cc');
    }
}

sfPopupRecoverPassword  = () =>{
    var returnUrl = window.location.pathname + window.location.search + '#recover';
    window.location.href = returnUrl;
}

openSfLoginPopup= () =>{
    $('#Watch-Finder--Drawer').removeClass('active');
    $('#sf_download_login_modal').css('display','flex');
    $('body').addClass('open-cc');
    
}

showPopupRegisterForm = () =>{
    $('#sf_download_login_modal .jsc-modal-content .shopify-section:first').show();
    $('#sf_download_login_modal .jsc-modal-content .shopify-section:first .row').show();
    $('#sf_download_login_modal .jsc-modal-content .shopify-section:last').hide();

}

showPopupLoginForm = () =>{
    $('#sf_download_login_modal .jsc-modal-content .shopify-section:first').hide();
    $('#sf_download_login_modal .jsc-modal-content .shopify-section:last').show();
    // Check if current URL has #recover
  if (window.location.hash === '#recover') {
    var returnUrl = window.location.pathname + window.location.search;
    window.location.href = returnUrl; 
  }
}

removeFromWatchList = (watchData,e) => {
    const customerID = $('jsc-watch-finder').attr('customer-id');
    let current = [];
  
    try {
      const get_watch_list = $('jsc-watch-finder').attr('customer-save-watch-list');
      current = get_watch_list ? JSON.parse(get_watch_list) : [];
  
      // Normalize if needed
      if (!Array.isArray(current)) current = [];
    } catch (e) {
      console.warn("⚠️ Failed to parse watch list during removal.", e);
      current = [];
    }
  
    // Remove matching item
    const updated = current.filter(item =>
      !(item.brand === watchData.brand &&
        item.collection === watchData.collection &&
        item.reference === watchData.reference)
    );
  
    // console.log("🧹 Updated list after removal:", updated);
  
    // Update attribute
    $('jsc-watch-finder').attr('customer-save-watch-list', JSON.stringify(updated));
  
    // Optional: POST to Mechanic to sync
    $.ajax({
      url: "https://webhooks.mechanic.dev/411d70c6-afc5-463b-9db8-583a633f213a",
      method: "POST",
      contentType: "application/json",
      data: JSON.stringify({
        customer_id: customerID,
        watches: updated,
      }),
    }).done(function (response) {
    //   console.log("✅ Watch removed successfully:", response);
    }).fail(function (error) {
      console.error("❌ Error removing watch data:", error);
    });

    // check if account page then remove the product card
    if ($('#_jscSavedWatchesList_display').length > 0) { 
       $(e).closest('.columns').remove(); 
     
       var columns = $('#_jscSavedWatchesList_display').find('.columns');

       columns.each(function () {
        const $col = $(this);
        const brand = $col.attr('data-brand') || '';
        const collection = $col.attr('data-collection') || '';
        const ref =  $col.attr('data-reference') || '';
  
        const isMatch = (
        brand.toLowerCase().includes(watchData.brand?.toLowerCase() || '') ||
        collection.toLowerCase().includes(watchData.collection?.toLowerCase() || '')
        ) && ref === watchData.reference;
  
        if (isMatch) {
          $col.remove();
        }
      });

            columns = $('#_jscSavedWatchesList_display').find('.columns');                    
            if (columns.length === 0) {
                $('#_jscSavedWatchesList_display').hide();
                $('#_jscSavedWatchesList_na').show();
            }

    }

  };

  
addToWatchList = (watchData) => {
    const $watchFinder = $('jsc-watch-finder');
    const customerID = $watchFinder.attr('customer-id');
    const rawWatchList = $watchFinder.attr('customer-save-watch-list');
    let current = [];
  
    try {
      if (rawWatchList) {
        const parsed = JSON.parse(rawWatchList);
  
        if (Array.isArray(parsed)) {
          current = parsed;
        } else if (typeof parsed === "object") {
          current = [parsed]; // wrap single object in array
        }
  
      }
    } catch (e) {
      console.warn("⚠️ Failed to parse watch list. Defaulting to empty list.", e);
      current = [];
    }
  
    // ✅ Check if item already exists
    const alreadyExists = Array.isArray(current) && current.some(watch =>
      watch.brand === watchData.brand &&
      watch.collection === watchData.collection &&
      watch.reference === watchData.reference
    );
  
    if (alreadyExists) {
      return;
    }
  
    // ✅ Add new watch
    current.unshift(watchData);
  
    // ✅ Keep only latest 50 items
    if (current.length > 50) {
      const removed = current.slice(50);
      console.log("🗑️ Removing old watches:", removed);
      current = current.slice(0, 50);
    }
  
    // ✅ Update DOM attribute
    $watchFinder.attr('customer-save-watch-list', JSON.stringify(current));
  
    // ✅ Send to Mechanic
    $.ajax({
      url: "https://webhooks.mechanic.dev/411d70c6-afc5-463b-9db8-583a633f213a",
      method: "POST",
      contentType: "application/json",
      data: JSON.stringify({
        customer_id: customerID,
        watches: current,
      }),
    })
    .done((response) => {
    // console.log("✅ Watch data submitted successfully:", response);
    })
    .fail((error) => {
      console.error("❌ Error submitting watch data:", error);
    });

    // check if account page then remove the product card
    if ($('#_jscSavedWatchesList_display').length > 0) { 
        
        var columns = $('#_jscSavedWatchesList_display').find('.columns');

     if (columns.length === 3) {
        columns.last().remove(); 
     }
            // Construct new card
            const html = `
            <div class="small-6 medium-4 columns" data-brand="${watchData.brand}" data-collection="${watchData.collection}" data-reference="${watchData.reference}">
            <product-card class="product-card text-left product-card--content-spacing-true product-card--border-false has-shadow--true">
                <figure class="product-featured-image thb-hover"> 
                <a href="${watchData.url || '#'}">
                    <img src="${watchData.watchImage}" alt="${watchData.brand} ${watchData.collection} ${watchData.reference}" />
                </a>
                <div class="jsc-sf-product-card-save-watch" onclick='removeFromWatchList(${JSON.stringify(watchData)}, this)'>  
                    <div class="sf-save-watch-button">
                    <span class="sf-save-watch-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 25 22" fill="none">
                        <path d="M12.4869 22C12.2364 21.9968 11.9918 21.9232 11.7804 21.7875C8.18822 19.57 5.48518 17.3766 3.2783 14.8705C2.01853 13.5287 1.04215 11.942 0.408559 10.207C-0.730606 6.84675 0.5832 2.9211 3.46882 1.07256C4.78425 0.221399 6.35422 -0.134962 7.90363 0.0659208C9.45304 0.266804 10.8831 1.01212 11.9431 2.17126C12.1376 2.37977 12.3162 2.60031 12.4869 2.81685C12.7194 2.51694 12.97 2.2317 13.2371 1.96275C13.8816 1.32075 14.6473 0.816306 15.4888 0.479444C16.3303 0.142583 17.2302 -0.0198119 18.1351 0.00192686C19.0214 0.0266866 19.8936 0.23235 20.6992 0.606539C21.5048 0.980728 22.2271 1.51571 22.8227 2.17928C25.0693 4.63732 25.6012 7.62065 24.3072 10.8045C23.6255 12.404 22.6611 13.8647 21.4613 15.1151C19.3548 17.3836 16.9713 19.3724 14.3683 21.0336C14.019 21.2662 13.6578 21.4907 13.3006 21.7113L13.1934 21.7795C12.9825 21.9174 12.738 21.9937 12.4869 22Z" stroke="#000000" fill="#000000"></path>
                        </svg>
                    </span>
                    </div>
                </div>
                </figure>
                <div class="product-card-info" style="background-color: #fff;">
                <a href="${watchData.url || '#'}">
                    <div class="fontWeight-6">${watchData.model || watchData.collection}</div>
                    <div style="margin-top: 10px;font-size: 15px; color: #7E7E7E;">Reference: ${watchData.reference}</div>
                </a>
                </div>
            </product-card>
            </div>`;

            $('#_jscSavedWatchesList_display').find('.grid').prepend(html);

            $('#_jscSavedWatchesList_display').show();
            $('#_jscSavedWatchesList_na').hide();
     
     }
}
  

// Function to update pagination index
updatePaginationIndex = (totalPage, activePage, htmlArray) => {
    const paginationContainer = $('#jsc-pagination-container');
    const paginationPages = paginationContainer.find('.jsc-pagination-pages');
    paginationPages.children().remove();
    paginationPages.removeClass('add-border');
    // Check if htmlArray has more than 8 elements
    if (htmlArray.length > 8){
      // Loop through the total number of pages
      for (let index = 1; index <= totalPage; index++) {
          // If it's the active page, add a current page class
          if (index === activePage) {
              paginationPages.addClass('add-border');
              paginationPages.append(`<span class="jsc-currentPage jsc-pagination-index m-l-10 m-r-10">${index}</span>`);
          } else {
              // Add pagination index with onclick function to paginate
              paginationPages.addClass('add-border');
              paginationPages.append(`<span class="jsc-pagination-index cursor m-l-10 m-r-10 " onclick="paginate('${htmlArray.join('---')}',${index})">${index}</span>`);
          }
      }
    }
  };


  // Function to paginate and load new li elements
paginate = (htmlString, pageIndex) => {
    $('.jsc-reinit-year-list').children().remove();
    $('jsc-year-list').show();
    const galleryContainer = $('jsc-year-reference-img');
    const htmlArray = htmlString.split('---');
    const isFromPaginate = true;
  
    // Remove existing li elements and pagination
    galleryContainer.children().remove();
    $('.jsc-pagination-pages').children().remove();
  
    // Load new li elements with pagination
    loadTableRow(htmlArray, pageIndex, isFromPaginate);
  };

populateInfoHtml = (reference) => {
    // Convert the model to a number if it's a string
    var referenceToMatch = isNaN(reference) ? reference : parseFloat(reference);

    // Filter data based on the 'brand'
    var filteredData = cachedWatchDb.filter(function(item) {
        return item.status === 1 && item.reference === referenceToMatch;
    });
            
    var infoUlElement1 = $('.placeholder-details .case-diameter');
    var infoUlElement2 = $('.placeholder-details .case-lug-distance');
    var infoUlElement4 = $('.placeholder-details .case-lug-width');
    var infoUlElement5 = $('jsc-year-placeholder').find('.year-img');

    var caseDiameter = filteredData.map(item => item.caseDiameter);
    var caseLugDistance = filteredData.map(item => item.lugToLugDistance);
    var caseLugWidth = filteredData.map(item => item.lugWidth);
    var caseImage = filteredData.map(item => item.image);

    $('.placeholder-info').css('visibility','visible');
            
    infoUlElement5.attr('src',caseImage);
    infoUlElement5.show();

    infoUlElement1.text(caseDiameter ? caseDiameter : 'NA');
    infoUlElement2.text(caseLugDistance ? caseLugDistance : 'NA');
    infoUlElement4.text(caseLugWidth ? caseLugWidth : 'NA');
 } 
 
 loadBrandOption = (getBrandLocalStorage) => {
    // Step 1: Filter active items
    const watchDb = cachedWatchDb.filter(item => item.status === 1);

    // Step 2: Build brand-populate map
    const brandPopulateMap = {};
    watchDb.forEach(item => {
        if (item.populate && item.populate > 0) {
            if (!brandPopulateMap[item.brand] || item.populate < brandPopulateMap[item.brand]) {
                brandPopulateMap[item.brand] = item.populate;
            }
        }
    });

    // Step 3: Get top 10 by populate
    const popularBrands = Object.keys(brandPopulateMap)
        .sort((a, b) => brandPopulateMap[a] - brandPopulateMap[b])
        .slice(0, 10);

    // Step 4: Get full brand list A–Z (including top 10)
    const allBrands = [...new Set(watchDb.map(item => item.brand))].sort();

    // Step 5: Build list with sections
    const brandUlElement = $('#jsc-brand .custom-select__listbox');

    const createOptionLi = (brand) => {
        const handleizedBrand = handleizedString(brand);
        const isSelected = brand === getBrandLocalStorage;
        return `<li class="custom-select--item custom-select__option js-option" id="jsc-brand-${handleizedBrand}" data-value="${brand}" onclick="selectOption(this,'brand')" ${isSelected ? 'aria-selected="true"' : 'aria-selected="false"'}>
            <span class="${isSelected ? 'custom-select--active' : ''}">${brand}</span>
        </li>`;
    };

    const top10Header = `<li class="custom-select--item-top-brand custom-select--item custom-select__option js-option fontWeight-6">Top Brands</li>`;
    const top10Options = popularBrands.map(createOptionLi);

    const allBrandsHeader = `<li class="custom-select--item-top-brand custom-select--item custom-select__option js-option fontWeight-6">All Brands</li>`;
    const allOptions = allBrands.map(createOptionLi); 

    const finalList = [top10Header, ...top10Options, allBrandsHeader, ...allOptions];

    brandUlElement.html(finalList.join(''));
}


loadModelOption = (brand, isPageType) => {
      // Call the function to populate the model HTML
      var getModelLocalStorage = localStorage.getItem('model');
      populateModelHtml(brand, getModelLocalStorage, isPageType);
  
      // Reset model and engine options
      resetModelOption();
  
      // Reset local storage
      setLocalStorage('model', '');
      setLocalStorage('reference', '');
  
}

loadReferenceOption= (brand,model) => {
    // Call the function to populate the model HTML
    populateReferenceHtml(brand,model);
  
    // Reset reference and engine options
    resetReferenceOption();

    setLocalStorage('reference', '');
}

loadEngineOption = (model,isPageType,brand) => {
    // Fetch JSON data from the URL
    if(brand && !model){
        populateReferenceImageHtmlByBrand(brand,isPageType);
    }else{
        populateReferenceImageHtml(model,isPageType,brand);
    }
 
    // reset local storage
    setLocalStorage('reference', '');
}

selectOption = (e, key) => {
    var _this = $(e);
    var value = _this.attr('data-value');
    // $('#Watch-Finder--Drawer').removeClass('active');
    $('.box.jsc-watch-finder--clear').show();
    $('jsc-reinit-year-list').hide();
    $('jsc-year-list').show();
    
    // Set Local storage
    setLocalStorage(key, value);

    var isPageType =  $('jsc-watch-finder--drop-down').attr('sfPageType');

    // Enable model option
    if (key == 'brand') {
    // Replace selected value
    var brandValue = "Brand: " + value;
    _this.closest('.jsc-custom-select').find('.custom-select--button input').attr('placeholder',brandValue);
    _this.closest('.jsc-custom-select').find('.custom-select--button input').val(brandValue);

       var getModelLocalStorage = localStorage.getItem('model');
       loadModelOption(value);
       loadReferenceOption(value);
       loadEngineOption(getModelLocalStorage,isPageType,value);
       $('jsc-year-right-wrapper').hide(); 
       $('jsc-year-wrapper').hide();
       $('finder-paginate-facet').text();
       $('#jsc-brand').removeClass('custom-select--active');

       $('jsc-watch-finder-content').addClass('show-year');
       $('jsc-year-wrapper').show();
       $('jsc-year-right-wrapper').show();
       $('jsc-year-reference-img').show(); 
    } 
    
    // Display Result
    if (key == 'model') {
        // Replace selected value
        var brandValue = "Collection: " + value;
        _this.closest('.jsc-custom-select').find('.custom-select--button input').attr('placeholder',brandValue);
        _this.closest('.jsc-custom-select').find('.custom-select--button input').val(brandValue);

        $('#jsc-model ul li').removeClass('active-model');
        _this.addClass('active-model');
        var getBrandLocalStorage = localStorage.getItem('brand');

        if ($('jsc-watch-finder--drop-down').length > 0) { // only for watch finder template
            initLoader();
            loadEngineOption(value,isPageType,getBrandLocalStorage);
        }else{
            loadReferenceOption(getBrandLocalStorage,value);
        }
        setPlaceholder();
    
        $('jsc-watch-finder-content').addClass('show-year');
        $('jsc-year-wrapper').show();
        $('jsc-year-right-wrapper').show();
        $('jsc-year-reference-img').show();
        $('#jsc-model').removeClass('custom-select--active');
    }
}


setPlaceholder = () => {
    var getBrandLocalStorage = localStorage.getItem('brand');    
    $('.placeholder-brand-name').text(getBrandLocalStorage);
    $('.placeholder-info').css('visibility','hidden');    
}


resetBrandOption = () => {
    $('#jsc-brand .custom-select--button .jsc-brand-search').attr('placeholder','-- Select Brand --');
    $('#jsc-brand .custom-select--button .jsc-brand-search').text('');
    $('#jsc-brand .custom-select--button .jsc-brand-search').val('');
}

resetModelOption = () => {
    $('#jsc-model .custom-select--button .jsc-model-search').attr('placeholder','-- Select Model --');
    $('#jsc-model .custom-select--button .jsc-model-search').text('');
    $('#jsc-model .custom-select--button .jsc-model-search').val('');
}

resetReferenceOption = () => {
    $('#jsc-reference .custom-select--button .jsc-reference-search').attr('placeholder','-- Select Reference --');
    $('#jsc-reference .custom-select--button .jsc-reference-search').text('');
    $('#jsc-reference .custom-select--button .jsc-reference-search').val('');
}

setLocalStorage = (key, value) => {
    localStorage.setItem(key, value);
}

onloadPopulateWatchFilterFromLocalStorage = (getBrandLocalStorage,getModelLocalStorage) => { 
       if (getBrandLocalStorage) {
          // Load Model option if Brand is in local storage
          populateModelHtml(getBrandLocalStorage, getModelLocalStorage);
          var brandValue = "Brand: " + getBrandLocalStorage;
          $('#jsc-brand .custom-select--button .jsc-brand-search').attr('placeholder',brandValue);
          $('.box.jsc-watch-finder--clear').show();
          
       }
 
       if (getModelLocalStorage) {
        var brandValue = "Collection: " + getModelLocalStorage;
          $('#jsc-model .custom-select--button .jsc-model-search').attr('placeholder',brandValue);
          $('.box.jsc-watch-finder--clear').show();
       }
}

onloadPopulateReferenceFilterFromLocalStorage = (getBrandLocalStorage,getModelLocalStorage,getReferenceLocalStorage) => { 
    if (getBrandLocalStorage && getModelLocalStorage) {
        // Load reference option if Brand and Model is in local storage
        populateReferenceHtml(getBrandLocalStorage,getModelLocalStorage,getReferenceLocalStorage);
        var referenceValue = "Reference: " + getReferenceLocalStorage;
        if (getReferenceLocalStorage) {
            $('#jsc-reference .custom-select--button .jsc-reference-search').attr('placeholder',referenceValue);
         }
     }

}
onclickBrandDropdown = () => {
    $("#jsc-model").removeClass('custom-select--active');
}

onclickModelDropdown = () => {  
    $("#jsc-brand").removeClass('custom-select--active');
}


onclickReferenceDropdown = () => {  
    $("#jsc-brand").removeClass('custom-select--active');
    $("#jsc-model").removeClass('custom-select--active');
}

onclickBrandInput = () => {
    $("#jsc-model").removeClass('custom-select--active');
    $("#jsc-reference").removeClass('custom-select--active');

    var getModelLocalStorage = localStorage.getItem('model');
    if (getModelLocalStorage){
     $('#jsc-model input').addClass('jsc-placeholder-black-color');
    }

    $('#jsc-brand .custom-select--list ul li').each(function() {
        $(this).show();
    });
    $('#jsc-brand').addClass('custom-select--active');
    $('#jsc-brand input').removeClass('jsc-placeholder-black-color');
    $('#jsc-brand input').val('');
}

onclickModelInput = () => {
    // Hide brand dropdown
    $("#jsc-brand").removeClass('custom-select--active');
    $("#jsc-reference").removeClass('custom-select--active');
    $('#jsc-model .custom-select--list ul li').each(function() {
        $(this).show();
    });
    $('#jsc-model').addClass('custom-select--active');
    $('#jsc-model input').removeClass('jsc-placeholder-black-color');
    $('#jsc-model input').val('');
}

onclickReferenceInput = () => {
    // Hide reference dropdown
    $("#jsc-brand").removeClass('custom-select--active');
    $("#jsc-model").removeClass('custom-select--active');

    $('#jsc-reference .custom-select--list ul li').each(function() {
        $(this).show();
    });

    $('#jsc-reference').addClass('custom-select--active');
    $('#jsc-reference input').val('');
}

brandFilterFunction = (e) => {
    // console.log('brandFilterFunction');
    var filter = $(e).val().toUpperCase();
    $('#jsc-brand').addClass('custom-select--active');

    var ulElement = $('#jsc-brand .custom-select--list ul');
    ulElement.show();

    $('#jsc-brand .custom-select--list ul li').each(function() {
        var txtValue = $(this).text().toUpperCase();
        if (txtValue.indexOf(filter) > -1) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });

       // Check if there are any visible list items
       var checkLiEle = ulElement.find('li:visible');
       if (checkLiEle.length === 0) {
           ulElement.hide(); // Hide the <ul> element if no visible list items
       } else {
           ulElement.show(); // Show the <ul> element if there are visible list items
       }
}

modelFilterFunction = (e) => {
    // console.log('modelFilterFunction');
    var filter = $(e).val().toUpperCase();
    $('#jsc-model').addClass('custom-select--active');

    var ulElement = $('#jsc-model .custom-select--list ul');
    ulElement.show();

    $('#jsc-model .custom-select--list ul li').each(function() {
        var txtValue = $(this).text().toUpperCase();
        if (txtValue.indexOf(filter) > -1) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });

       // Check if there are any visible list items
       var checkLiEle = ulElement.find('li:visible');
       if (checkLiEle.length === 0) {
           ulElement.hide(); // Hide the <ul> element if no visible list items
       } else {
           ulElement.show(); // Show the <ul> element if there are visible list items
       }
}

referenceFilterFunction = (e) => {
    // console.log('referenceFilterFunction');
    var filter = $(e).val().toUpperCase();
    $('#jsc-reference').addClass('custom-select--active');
    // $('#jsc-reference input').removeClass('jsc-placeholder-black-color');

    var ulElement = $('#jsc-reference .custom-select--list ul');
    ulElement.show();

    $('#jsc-reference .custom-select--list ul li').each(function() {
        var txtValue = $(this).text().toUpperCase();
        if (txtValue.indexOf(filter) > -1) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });

       // Check if there are any visible list items
       var checkLiEle = ulElement.find('li:visible');
       if (checkLiEle.length === 0) {
           ulElement.hide(); // Hide the <ul> element if no visible list items
       } else {
           ulElement.show(); // Show the <ul> element if there are visible list items
       }
}

toggleBrandDropdown = () => {
    $("#jsc-brand").toggleClass('custom-select--active');
}

toggleModelDropdown = () => {
    $("#jsc-model").toggleClass('custom-select--active');
}

toggleReferenceDropdown = () => {
    $("#jsc-reference").toggleClass('custom-select--active');
}

backToYearImg = () => {
   var list =  $('#jsc-model .custom-select--list ul li');
   var model = localStorage.getItem('model');
   list.each(function(){
        if ($(this).attr('data-value') == model){
            $(this).click();
        }
    });  
}

disabledAllSelection = () => {
    // Model
    $('#jsc-model .custom-select__listbox').html(blankLi);;
 
    // reset local storage
    setLocalStorage('brand', '');
    setLocalStorage('model', '');
    setLocalStorage('reference', '');
    
}

clearSelection = () => {
    resetBrandOption();
    resetModelOption();

    $('finder-paginate-facet').text();
    $('jsc-year-right-wrapper').hide();
    $('.box.jsc-watch-finder--clear').hide();
    $('jsc-watch-finder-content').removeClass('show-year');
    
    var paginationContainer = $('#jsc-pagination-container');
    var paginationPages = paginationContainer.find('.jsc-pagination-pages');
    paginationPages.children().remove();
    paginationPages.removeClass('add-border');
 
    $('jsc-year-reference-img').children().remove();
    disabledAllSelection();
    disabledeWatchBtn();
}

onloadWatchButton = (getBrandLocalStorage,getModelLocalStorage) => {
   $('.placeholder-info').css('visibility','hidden');

   if (getBrandLocalStorage && getModelLocalStorage){ 
        populateReferenceImageHtml(getModelLocalStorage);
        $('jsc-watch-finder-content').addClass('show-year');
        $('jsc-year-right-wrapper').show();
    }else if (getBrandLocalStorage && !getModelLocalStorage) {
        populateReferenceImageHtmlByBrand(getBrandLocalStorage);
        $('jsc-watch-finder-content').addClass('show-year');
        $('jsc-year-right-wrapper').show();
    }else{
        $('jsc-watch-finder-content').removeClass('show-year');
        $('jsc-year-right-wrapper').hide();
    }
}

showWatchInfo = () => {
    var brandName = localStorage.getItem('brand');
    $('.placeholder-details .placeholder-brand-name').text(brandName);
    $('jsc-watch-finder--description').hide();
}


enableWatchBtn = () => { 
    $('.jsc-search-watch-button').attr('disabled',false);
}

destroyYearArticleSlider = () =>{
    $('.jsc-reinit-year-article').flickity();
    $('.jsc-reinit-year-article').flickity('destroy');
  }


triggerMobilePopup = () =>{
    if($(window).width() < 1100){
        $('#PopupModal-watchfinder').attr('open',true)
    }
}
constructParamUrl = (index, e,isPageType) => {
    var $this = $(e);
    var $input = $this.find('input');
    
    // Get brand, model and year, remove spaces
    var $brand = $input.attr('brand').replace(/\s+/g, '');
    var $model = $input.attr('watch').replace(/\s+/g, '');
    var $year = $input.attr('year-ref').replace(/\s+/g, '');
    var $brandSpecificPage = $input.attr('brand-specific-page');
    var $modelLandingPage = $input.attr('model-landing-page');

    if (isPageType == 'brand'){
        if ($brandSpecificPage.includes('/pages')) {
            var findastrapLink = $brandSpecificPage;
        }else{
            var findastrapLink = window.location.pathname;  
        }
    }else if (isPageType == 'model'){
        var findastrapLink = $modelLandingPage;  
    }else {
        var findastrapLink = $('.jsc-watch-finder').attr('sf-page');
        findastrapLink = '/pages/'+findastrapLink;
    }

    // Construct URL properly
    var urlWithParams = `${findastrapLink}?brand=${encodeURIComponent($brand)}collection=${encodeURIComponent($model)}reference=${encodeURIComponent($year)}`;
    window.location.href = urlWithParams;
}
constructYearWrapper = (index,e) => {
    var $this = $(e);
  if (!$this.find('.product-card').hasClass('border-active')) {

    $('jsc-watch-finder .product-card').removeClass('border-active');
    $this.find('.product-card').addClass('border-active');

    var wrapper = $('.jsc-reinit-year-list');
    wrapper.children().remove();
    $('.article-slider-wrapper').remove();
    $('jsc-year-list').hide();

    $('jsc-reinit-year-list').show();
    $('jsc-year-list').hide();


        var $this_input = $this.find('input');
        destroyYearArticleSlider();
        // Get the image source from the attribute
        var img_src = $this_input.attr('year-src');
        var case_diameter = $this_input.attr('case-diameter');
        var lug_distance = $this_input.attr('lug-to-lug-distance');
        var lug_width = $this_input.attr('lug-width');
        var article_urls = $this_input.attr('article-urls');

        // Create a new div for each element
        const newDiv = $('<div>').addClass('jsc_carousel__slide').attr('data-index',index);

        // Append an image to the new div
        newDiv.append($('<img>').attr('src', img_src));

        // Create the placeholder-details div
        var placeholderDetailsDiv = $('<div>').addClass('placeholder-details');

        // Create the brand-name and brand-info divs
        var brandName = localStorage.getItem('brand');
        var referenceName  = localStorage.getItem('reference');
        var brandNameDiv = $('<div>').addClass('brand-name fontWeight-6 m-b-5 text-left').text(brandName);
        var referenceDiv = $('<div>').addClass('reference-name text-left').text("Reference: " + referenceName);
        
         var brandInfoDiv = $('<span>').addClass('brand-info text-left m-r-5').text('');
        brandInfoDiv.append("Case diameter: " + (case_diameter ? case_diameter + "mm," : "-"));

        var lugWidthBrandInfoDiv = $('<span>').addClass('brand-info text-left').text('');
        lugWidthBrandInfoDiv.append("Lug width: " + (lug_width ? lug_width + "mm" : "-"));

        var lugBrandInfoDiv = $('<div>').addClass('brand-info text-left').text('');
        lugBrandInfoDiv.append("Lug-to-lug: " + (lug_distance ? lug_distance + "mm" : "-"));

        var infoBtnWrapperDiv = $('<div>').addClass('info-btn-wrapper');

        // var findStrapButton = $('<div>').attr('onclick', 'findStrap()').addClass('button accent').text('Find A Strap');
        var recommendStrapButton = $('<div>').attr('onclick', 'findStrap("recommended")').addClass('button accent').text('Shop Recommended Straps');
        var viewAllStrapButton = $('<div>').attr('onclick', 'findStrap("all")').addClass('button').text('View All Compatible Straps');
 
        infoBtnWrapperDiv.append(recommendStrapButton);
        infoBtnWrapperDiv.append(viewAllStrapButton);
        placeholderDetailsDiv.append(brandNameDiv, referenceDiv, brandInfoDiv, lugWidthBrandInfoDiv, lugBrandInfoDiv);

        newDiv.append(placeholderDetailsDiv);
        newDiv.append(infoBtnWrapperDiv);

        wrapper.append(newDiv);

        constructBlogSlider(article_urls);
  }
}

constructBlogSlider = (urls) => {
    let urlArray = urls.split('>').map(url => url.trim()).filter(url => url !== "");
    var sliderWrapper = $('<div>').addClass('article-slider-wrapper');
    var ajaxCalls = []; 

    urlArray.forEach(url => {
        let cleanUrl;
        try {
            cleanUrl = new URL(url).pathname;
        } catch (e) {
            cleanUrl = url;
        }

        let ajaxCall = $.ajax({
            url: cleanUrl,
            cache: false,
            success: function(response) {
                var title = $(response).find('h1').text().trim();
                var pageTitle = $(response).find('title').text().trim();
                pageTitle = pageTitle.replace(/\s*[-–]\s*Delugs$/, ''); 
                var postDate = $(response).find('#main-content .post-meta-wrapper time').text().trim(); 
                var thirdParagraph = $(response).find('#main-content .rte p').eq(2).text().trim();
                var preview = thirdParagraph.substring(0, 110) + '...';
                var featuredImage = $(response).find('.blog-post-detail--wrapper .featured-image img').attr('src');

                var articleDiv = $('<div>').addClass('article-slide');

                if (title) {
                    var titleElement = $('<h6 class="fontWeight-6 text-center">').text(title);
                    articleDiv.append(titleElement);
                }

                var contentWrapper = $('<div>').addClass('content-wrapper').css('padding', '15px');

                if (featuredImage) {
                    var imgWrapper = $('<div>').addClass('featured-image m-b-10');
                    var img = $('<img>').attr('src', featuredImage).attr('alt', title).attr('width', '440').attr('height', '300');
                    imgWrapper.append(img);
                    contentWrapper.append(imgWrapper);
                }

                var datelement = $('<div class="article-date m-b-10" style="color:#8888">').text(postDate);
                contentWrapper.append(datelement);

                var pageTitleElement = $('<div class="page-title m-b-10 fontWeight-6" style="color:var(--color-accent)">').text(pageTitle);
                contentWrapper.append(pageTitleElement);

                var previewText = $('<div class="rte m-b-10">').text(preview);
                contentWrapper.append(previewText);

                var readMoreLink = $('<a class="m-b-10">').attr('href', url).attr('target', '_blank').text('Read more >').css('color', 'var(--color-accent)');
                contentWrapper.append(readMoreLink);

                articleDiv.append(contentWrapper);

                // Append articleDiv to sliderWrapper
                sliderWrapper.append(articleDiv);
            },
            error: function() {
                console.log("Failed to fetch blog article:", cleanUrl);
            }
        });

        ajaxCalls.push(ajaxCall);
    });

    $.when.apply($, ajaxCalls).done(function() {
  
        $('jsc-year-right-wrapper').append(sliderWrapper);

        $('.article-slider-wrapper').flickity({
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            autoPlay: 3000
        });
    });
};

initLoader = () => {
    var $html = `<div class="jsc-page-loading">
        <div class="jsc-spinner-container">
        <div class="jsc-spinner"></div>
        </div>
        </div>`;
    $('body').prepend($html);
}

removeLoader = () => {
    setTimeout(function(){
        $('.jsc-page-loading').remove();
    },2500);
}

findStrap = (type) => {

    localStorage.setItem('strapOnlyFilter', type);
    var findastrapLink = $('jsc-watch-finder').attr('sf-page');
    findastrapLink = '/pages/'+findastrapLink;
    var recommendCol = $('.jsc-year-img-items .border-active').parent().find('.jsc-year-img-data').attr('recommend-collection');;
    localStorage.setItem('recommendCol', recommendCol);

    var watchFace = $('.jsc-year-img-items .border-active').parent().find('.jsc-year-img-data').attr('watch-face');;
    localStorage.setItem('watchFace', watchFace);
    
    $('.brand-info').each(function() {
        var text = $(this).text(); 
        if (text.includes('Case diameter:')) {
          var caseDiameter = text.match(/[\d.]+/)[0];
          localStorage.setItem('caseDiameter', caseDiameter);
        }
      
        if (text.includes('Lug width:')) {
            var match = text.match(/[\d.]+/);
            if (match) { 
                var lugWidth = match[0]; 
                localStorage.setItem('lugWidth', lugWidth);
            } else {

                localStorage.setItem('lugWidth', '');
            }
        }
      
      });  

    window.location.href = findastrapLink;
}